export const portfolioCommentaryBlockBaseQueryKey = "portfolioCommentaryWidget";
